/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {useAuth} from '../../../../app/modules/auth'

export function AsideMenuMain() {
  const intl = useIntl()

  const {currentUser} = useAuth()

  return (
    <>
      {(() => {
        if (currentUser) {
          if (currentUser.rol == 'Admin') {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Sitio Web
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/homepage'
                  icon='/media/icons/duotune/general/gen001.svg'
                  title='Inicio'
                />
                {/* <AsideMenuItem
                  to='#'
                  icon='/media/icons/duotune/general/gen006.svg'
                  title='Banners'
                /> */}
                <AsideMenuItem
                  to='/marcas'
                  icon='/media/icons/duotune/abstract/abs051.svg'
                  title='Marcas'
                />

                <AsideMenuItemWithSub
                  to='/crafted/pages'
                  title='Catálogo'
                  fontIcon='bi-archive'
                  icon='/media/icons/duotune/general/gen009.svg'
                >
                  {/* <AsideMenuItem to='#' title='Categorías' hasBullet={true} /> */}
                  <AsideMenuItem to='/catalogo/productos' title='Productos' hasBullet={true} />
                  {/* <AsideMenuItem to='#' title='Lista en Excel' hasBullet={true} /> */}
                </AsideMenuItemWithSub>
                <AsideMenuItem
                  to='/generales'
                  icon='/media/icons/duotune/general/gen019.svg'
                  title='Generales'
                />

                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Usuarios
                    </span>
                  </div>
                </div>
                {/* <AsideMenuItem
                  to='#'
                  icon='/media/icons/duotune/communication/com013.svg'
                  title='Administradores'
                /> */}
                {/* <AsideMenuItem
                  to='#'
                  icon='/media/icons/duotune/communication/com014.svg'
                  title='Vendedores'
                /> */}
                <AsideMenuItem
                  to='/distribuidores'
                  icon='/media/icons/duotune/ecommerce/ecm006.svg'
                  title='Distribuidores'
                />
                <AsideMenuItem
                  to='/vendedores'
                  icon='/media/icons/duotune/communication/com006.svg'
                  title='Vendedores'
                />

                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Portal</span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/portal/pedidos'
                  icon='/media/icons/duotune/ecommerce/ecm002.svg'
                  title='Pedidos'
                />
                <AsideMenuItem
                  to='/portal/listas-precios'
                  icon='/media/icons/duotune/ecommerce/ecm008.svg'
                  title='Listas de precios'
                />
              </>
            )
          } else if (currentUser.rol == 'Vendedor') {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Portal Vendedor
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/portal-vendedor/mis-pedidos'
                  icon='/media/icons/duotune/ecommerce/ecm008.svg'
                  title='Mis Pedidos'
                />
                <AsideMenuItem
                  to='/portal-vendedor/mi-perfil'
                  icon='/media/icons/duotune/communication/com006.svg'
                  title='Mi Perfil'
                />
              </>
            )
          } else if (currentUser.rol == 'Gestor') {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Sitio Web
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='#'
                  icon='/media/icons/duotune/abstract/abs051.svg'
                  title='Marcas'
                />

                <AsideMenuItemWithSub
                  to='/crafted/pages'
                  title='Catálogo'
                  fontIcon='bi-archive'
                  icon='/media/icons/duotune/general/gen009.svg'
                >
                  <AsideMenuItem to='#' title='Categorías' hasBullet={true} />
                  <AsideMenuItem to='#' title='Productos' hasBullet={true} />
                  <AsideMenuItem to='#' title='Lista en Excel' hasBullet={true} />
                </AsideMenuItemWithSub>

                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Portal</span>
                  </div>
                </div>
                <AsideMenuItem
                  to='#'
                  icon='/media/icons/duotune/ecommerce/ecm002.svg'
                  title='Pedidos'
                />
                <AsideMenuItem
                  to='#'
                  icon='/media/icons/duotune/ecommerce/ecm008.svg'
                  title='Listas de precios'
                />
              </>
            )
          } else {
            return (
              <>
                <div className='menu-item'>
                  <div className='menu-content pt-8 pb-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                      Portal Distribuidores
                    </span>
                  </div>
                </div>
                <AsideMenuItem
                  to='/portal/mis-pedidos'
                  icon='/media/icons/duotune/ecommerce/ecm002.svg'
                  title='Mis Pedidos'
                />
                <AsideMenuItem
                  to='/portal/mi-perfil'
                  icon='/media/icons/duotune/communication/com006.svg'
                  title='Mi Perfil'
                />
              </>
            )
          }
        }
      })()}
    </>
  )
}
